import { useState, useEffect, useRef } from 'react';

const steps = [
  {
    number: '01',
    title: '상담 신청',
    description: '카카오톡으로 간편하게 상담을 신청하세요',
    icon: 'ri-chat-3-line',
  },
  {
    number: '02',
    title: '요구사항 확인',
    description: '원하시는 디자인 스타일과 내용을 상세히 논의합니다',
    icon: 'ri-file-list-3-line',
  },
  {
    number: '03',
    title: '디자인 제작',
    description: '전문 디자이너가 맞춤형 디자인을 제작합니다',
    icon: 'ri-palette-line',
  },
  {
    number: '04',
    title: '수정 및 완성',
    description: '피드백을 반영하여 최종 결과물을 완성합니다',
    icon: 'ri-check-double-line',
  },
];

export default function ProcessSection() {
  const [visibleSteps, setVisibleSteps] = useState<boolean[]>([false, false, false, false]);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            steps.forEach((_, index) => {
              setTimeout(() => {
                setVisibleSteps((prev) => {
                  const newState = [...prev];
                  newState[index] = true;
                  return newState;
                });
              }, index * 300);
            });
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">진행 과정</h2>
          <p className="text-gray-600 text-lg">
            간단하고 명확한 4단계 프로세스로 진행됩니다
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`relative transition-all duration-700 ${
                visibleSteps[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group hover:-translate-y-2">
                <div className="w-16 h-16 bg-neon-light rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
                  <i className={`${step.icon} text-3xl text-neon-pink`}></i>
                </div>
                <div className="text-5xl font-black text-neon-pink/20 mb-4 group-hover:text-neon-pink/40 transition-colors">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold mb-3 group-hover:text-neon-pink transition-colors">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-neon-pink animate-pulse"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
